/** Hard navigations, behind an object so tests can replace them (jsdom does not implement navigation). */
export const nav = {
  /** Full reload on `/`: unmounts the whole app and drops every in-memory patient state. */
  reloadToRoot(): void { window.location.replace('/'); },
};
